import { Box, BoxProps, Text } from '@jfs/ui-new'
import { FC, useState } from 'react'
import { sortPermissionHeader } from '../../data/static/data'
import { tableItemStrings } from '../../data/static/strings'
import { isStringBlank } from '../../util/util'
import { getActionView } from './getActionView'
import { getDateView } from './getDateView'
import { ItemView } from './ItemView'
import { styles } from './styles'
import { ActionType, TableItemProps } from './types'

const TableItem: FC<TableItemProps> = ({
  data,
  disableItem = false,
  onPress,
  handleSort,
  extendedColumns = [],
  from,
  transactionType = 0,
  freezeColumn,
  isFreeze,
  sortDetails,
  onAction,
  onDownloadFileAction,
  onChangeInput,
  onDownloadReportFile,
  onDeleteReportFile,
  onEditReport,
}: TableItemProps) => {
  const [isHovering, setIsHovering] = useState(false)
  const [copied, setCopied] = useState(false)
  const viewStyles = data.id === '0' ? styles.header : styles.item
  const viewStylesInner = data.id === '0' ? styles.titleheaderView : styles.titleView
  const textStyles = data.id === '0' ? styles.titleHeader : styles.title
  const handleHover = (hovering: boolean): void => {
    setIsHovering(hovering && !disableItem)
    if (hovering === false) {
      setCopied(false)
    }
  }

  const defaultView = (entry: any, statusStyle1: BoxProps) => {
    return (
      <Box {...statusStyle1}>
        <Text
          {...(tableItemStrings.link?.includes(entry.id) ? styles.linkStyle : textStyles)}
          color={styles[entry.value]?.color}>
          {`${isStringBlank(entry.value) ? 'NA' : entry.value}`}
        </Text>
      </Box>
    )
  }

  const executeAction = (actionType: ActionType) => {
    if (onAction) {
      onAction(actionType, data.id)
    }
  }

  const getLoadingView = () => {
    if (data.id !== tableItemStrings.loading) {
      return null
    }
    return (
      <Box {...styles.gridStyle} key={'2' + data.id} show={data.id === tableItemStrings.loading}>
        <Box {...viewStylesInner} {...styles.loading}>
          {getDateView({ id: 0, value: data.date }, textStyles)}
          {defaultView({ id: 1, value: data.loading }, textStyles)}
          {getActionView(data?.action ?? '', executeAction, true, data.id === tableItemStrings.loading)}
        </Box>
      </Box>
    )
  }

  const getItemView = (entry: any) => {
    return ItemView(
      entry,
      handleSort,
      extendedColumns,
      from,
      transactionType,
      data,
      isHovering,
      copied,
      setCopied,
      isFreeze,
      freezeColumn,
      sortDetails,
      onAction,
      onDownloadFileAction,
      onChangeInput,
      onDownloadReportFile,
      onDeleteReportFile,
      onEditReport,
    )
  }

  const headerData =
    data.id === '0' &&
    Object.entries(data).map((entry) => ({
      id: entry[0],
      value: entry[1],
      sortAllow: sortPermissionHeader?.includes(entry[1]),
      index: data.id,
    }))
  const loadingData = data.id === tableItemStrings.loading && data
  const listItemData =
    data.id !== '0' &&
    data.id !== tableItemStrings.loading &&
    Object.entries(data).map((entry) => ({
      id: entry[0],
      value: entry[1],
      sortAllow: sortPermissionHeader?.includes(entry[1]),
      index: data.id,
    }))

  return (
    <Box
      onHover={handleHover}
      hoverColor={'GREYISH_WHITE'}
      onPress={onPress}
      underlayColor={'GREY_SEPARATOR'}
      disabled={data.id === '0' || disableItem || data.disabled}
      {...viewStyles}
      opacity={data.disabled ? 0.5 : 1}
      testID="table-item">
      <Box {...styles.containerBox} alignItems="center">
        {headerData && headerData.map(getItemView)}
        {loadingData && getLoadingView()}
        {listItemData && listItemData.map(getItemView)}
      </Box>
    </Box>
  )
}

export { TableItem }
